export const DEFAULT_THEME_COLOR = "#CC0000";
export const VIDEO_FORMATS = ["mp4"];
export const CAPTURE_BK_BTN_PRIORITY = 100;
export const SUPPORTED_LANGUAGES = ["ar", "de", "en", "es", "fr", "it", "ja", "ko", "nl", "pt", "zh"];
